import {FiSave} from "react-icons/fi";

import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButtonGroup} from "@/components/dropdownButtonGroup/DropdownButtonGroup.tsx";

interface SaveChartButtonProps {
  canSave: boolean;
  onSave: () => void;
  onSaveAs: () => void;
}

export const SaveChartButton = ({canSave, onSave, onSaveAs}: SaveChartButtonProps) => (
  <DropdownButtonGroup title="Save" icon={FiSave} variant="primary" onClick={onSave} disabled={!canSave}>
    <DropdownItem onClick={onSaveAs} disabled={!canSave}>
      Save as new
    </DropdownItem>
  </DropdownButtonGroup>
);
